import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import TextField from "@mui/material/TextField"; // Ensure you import TextField from MUI
import React, { useState, useEffect } from "react";
import DataTableTransfertsEntreCompte from "../../ui/DataTableTransfertsEntreCompte";
import SellingService from "../../services/SellingService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableTransfertsEntreComptePlusInfo from "../../ui/DataTableTransfertsEntreComptePlusInfo";
import DataTableTransfertsEntrePayementInformations from "../../ui/DataTableTransfertsEntrePayementInformations";
const TransfertEntreComptesPusInfo = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  // States for date fields
  const [info, setInfo] = useState(null);
  const [payementInformations, setPayementInformations] = useState(null);


  useEffect(() => {
    const storedInfo = sessionStorage.getItem("infoId");
    if (storedInfo) {
      startLoading()
      SellingService.getPayementInfoByPayementTransfert(getCurrentUserId(), storedInfo)
        .then((response) => {
          setInfo([response.data.success.payementTransfert]);
          setPayementInformations(response.data.success.payementInformations)
        })
        .catch((error) => {
          console.error("Error fetching payment info:", error);
        }).finally(() => {
          stopLoading()
        });
    }
  }, []);






  // Navigate function
  const navigateToAddTransfertAccounts = () => {
    navigate("/addTransfertsEntreCompte");
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card mt-3">
                <div className="card-body">
                  <h3 className="card-title">Détails des Transferts Entre Comptes</h3>
                </div>
              </div>


              {info && <DataTableTransfertsEntreComptePlusInfo data={info} title={`Plus d'Info Transferts Entre Comptes - Référence: ${info[0].ref}`} details={true} />}
              {payementInformations && <DataTableTransfertsEntrePayementInformations data={payementInformations} title={`Informations de Paiement`} details={true} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLoader(TransfertEntreComptesPusInfo);
